// extracted by mini-css-extract-plugin
module.exports = {"container":"recipeList_container__sh7Zp","header":"recipeList_header__dIYOR","title":"recipeList_title__zyECz","shimmer":"recipeList_shimmer__3QP_8"};